import Splide from '@splidejs/splide';
import luxy from 'luxy.js';

/**
 * Aboutページに関する処理
 */

export default class PageAbout {
  constructor(_parm) {
    this.parent = document.querySelector('#js-page-about') || false;
    if (!this.parent) return;
  }

  /**
   * visionのスライダー
   */
  slider() {
    const mySplide = new Splide('#js-slider', {
      autoplay: true,
      type: 'fade',
      interval: 3000,
      speed: 3000,
      pauseOnFocus: false,
      arrows: false,
      drag: false,
      rewind: true,
    });
    mySplide.mount();
  }

  init() {
    if (!this.parent) return;
    this.slider();
    if (window.outerWidth >= 768) {
      luxy.init({
        wrapperSpeed: 0.1
      });
    }
  }
}
